export const PasswordUtils = {
    generatePassword: () => {
        const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
        const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const specialChars = '&%$#!';

        const allChars = lowerChars + upperChars + numbers + specialChars;

        let password = '';

        // Ensure at least one character from each required set
        password += upperChars[Math.floor(Math.random() * upperChars.length)];
        password += numbers[Math.floor(Math.random() * numbers.length)];
        password += specialChars[Math.floor(Math.random() * specialChars.length)];

        // Fill the rest of the password length with random characters from all sets
        for (let i = 3; i < 12; i++) {
            password += allChars[Math.floor(Math.random() * allChars.length)];
        }

        // Shuffle the password to avoid predictable patterns
        password = password
            .split('')
            .sort(() => 0.5 - Math.random())
            .join('');

        return password;
    },
};
